module.exports = __webpack_public_path__ + "static/media/entryhall.101c921e.obj";